import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import moment from 'angular-moment';
import routing from './weekly_active_report.routes';

import DailyActivePowerService from '../../../components/api/daily_active_power/daily_active_power.service';
import ActivePowerService from '../../../components/api/active_power/active_power.service';
import WeatherService from '../../../components/api/weather/weather.service';
import DailyWeatherService from '../../../components/api/daily_weather/daily_weather.service';
import CompareWeatherLogic from '../../../components/logic/compare_weather/compare_weather.logic';
import Chart from '../../../components/directive/chart/chart.directive';
import DateUtil from '../../../components/logic/date_util/date_util.module';
import CsvUtil from '../../../components/logic/csv_util/csv.util';
import PowerFormatter from '../../../components/logic/power-formatter/power-formatter.logic';
import chartConfig from './weekly_active_report.config';

export class WeeklyActiveReportController {
  /*@ngInject*/
  constructor($stateParams, $filter, $state, $q, moment, PowerFormatter, DateUtil, DailyActivePowerService, ActivePowerService, CsvUtil, CompareWeatherLogic, WeatherService, DailyWeatherService) {
    this.id = $stateParams.id;
    this.$filter = $filter;
    this.$state = $state;
    this.$q = $q;
    this.DailyActivePowerService = DailyActivePowerService;
    this.ActivePowerService = ActivePowerService;
    this.WeatherService = WeatherService;
    this.DailyWeatherService = DailyWeatherService;
    this.CompareWeatherLogic = CompareWeatherLogic;
    this.PowerFormatter = PowerFormatter;
    this.moment = moment;
    this.DateUtil = DateUtil;
    this.CsvUtil = CsvUtil;

    this.targetDate = this.moment().startOf('week');
    this.startDate = this.targetDate.clone().toDate();
    this.endDate = this.targetDate.clone().add(6, 'days').toDate();
    this.maxDate = this.targetDate.clone().toDate();
    this.downloadFileName = 'active_power_daily.csv';
    this.bulkDownloadFileName = 'active_power_hourly.csv';
    this.bulkCsvGenerator = () => {
      return this.createBulkCsv();
    };
    this.downloading = false;

    this.Week = ['日', '月', '火', '水', '木', '金', '土'];

    this.categories = [];
    for (let i = 0; i < 7; i++) {
      let utc = this.DateUtil.localToUTC(this.startDate);
      this.categories.push(this.DateUtil.leapDate(utc, i).valueOf());
    }

    this.chartConfig = chartConfig(this);
  }

  $onInit() {
    this.updateGraph(this.startDate, this.endDate);
  }

  updateGraph(startDate, endDate) {
    this.categories = [];
    for (let i = 0; i < 7; i++) {
      let utc = this.DateUtil.localToUTC(startDate);
      this.categories.push(this.DateUtil.leapDate(utc, i).valueOf());
    }

    const query = angular.extend({
      id: this.id,
      sa_config_id: this.id
    }, this.DateUtil.getDateRangeQueries(startDate, endDate));

    this.$q.all([
      this.DailyActivePowerService.show(query).$promise,
      this.DailyWeatherService.api.index(query).$promise
    ]).then(responses => {
      const powers = responses[0];
      const weathers = responses[1];

      this.chart.xAxis[0].setCategories(this.categories);

      this.activePowerObjects = this.PowerFormatter.formatDailyActivePowers(powers.powers, this.categories);
      this.activePowers = this.activePowerObjects.map(power => {return power.y});
      this.weathers = this.CompareWeatherLogic.compareDaily(weathers, this.categories);
      const y = (this.weathers.length > 0) ? 50 : null;

      this.chart.xAxis[0].update({
        labels: {y: y}
      });

      this.itemWidth = 100 / 7;

      this.csvData = this.CsvUtil.processDailyActivePower(this.activePowers, this.categories, this.weathers);
      this.chart.series[0].setData(this.activePowerObjects);
      this.chart.reflow();
      this.setFilename(startDate);
    });
  }

  setFilename(targetDate) {
    const date = this.moment(targetDate);
    this.downloadFileName = date.format('[active_power_]YYYY-MM-DD[_week_daily.csv]');
    this.bulkDownloadFileName = date.format('[active_power_]YYYY-MM-DD[_week_hourly.csv]');
  }

  createBulkCsv() {
    this.downloading = true;
    let startDate = this.moment(this.startDate);
    let endDate = this.moment(this.endDate).add(1, 'day');

    const powerQuery = angular.extend(this.DateUtil.datetimeRangeQuery(startDate, endDate), {
      id: this.id,
      start_min: 0
    });
    const weatherQuery = angular.extend({sa_config_id: this.id}, this.DateUtil.getDateRangeQueries(startDate, endDate.subtract(1, 'day')));

    return new Promise(resolve => {
      this.$q.all([
        this.ActivePowerService.show(powerQuery).$promise,
        this.WeatherService.api.index(weatherQuery).$promise
      ]).then(responses => {
        resolve(this.CsvUtil.processBulkActivePower(responses[0].powers, responses[1]));
        this.downloading = false;
      });
    });
  }

  changeDate(diff) {
    this.startDate = this.DateUtil.leapDate(this.startDate, diff);
    this.endDate = this.DateUtil.leapDate(this.startDate, 6);

    this.updateGraph(this.startDate, this.endDate);
  }

  getWeek(timeValue) {
    return this.Week[new Date(timeValue).getDay()];
  }
}

export default angular.module('leptonApp.weeklyActiveReport', [uiRouter, moment, Chart, DateUtil, PowerFormatter, CsvUtil, CompareWeatherLogic, DailyActivePowerService, ActivePowerService, WeatherService, DailyWeatherService])
  .config(routing)
  .component('weeklyActiveReport', {
    require: {parentComponent: '^demandReportShow'},
    template: require('./weekly_active_report.html'),
    controller: WeeklyActiveReportController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/active_report/weekly/weekly_active_report.component.js